import React from 'react'

import './footer.scss'

const Footer = () => {

    return (
        <div className='footer'>
            <div className='footer__container'>
                <div className='footer-item logo'>
                    <div className='footer-logo'>
                        <img src={require('../Assets/Logo/logo.png')} alt='logo' />
                    </div>
                    <p>
                        We provide a range of comprehensive IT services
                        while ensuring excellent service delivery by our
                        experts.
                    </p>
                    {/* <div className='footer-social'>
                        <h3>Follow Us</h3>
                        <div className='footer-social__icons'>
                            <a href='/' target='_blank' rel='noopener noreferrer'>
                                <FacebookFilled />
                            </a>

                            <a href='/' target='_blank' rel='noopener noreferrer'>
                                <InstagramFilled />
                            </a>

                            <a href='/' target='_blank' rel='noopener noreferrer'>
                                <LinkedinFilled />
                            </a>

                            <a href='/ ' target='_blank' rel='noopener noreferrer'>
                                <YoutubeFilled />
                            </a>

                            <a href='/ ' target='_blank' rel='noopener noreferrer'>
                                <TwitterCircleFilled />
                            </a>
                        </div>
                    </div> */}
                </div>

                <div className='footer-item footer-links'>
                    <h3>Company Links</h3>
                    <ul>
                        <li><a href="/#about-us">About Us</a></li>
                        <li><a href='/#services'>Services</a></li>
                        <li><a href='/#team'>Team</a></li>
                        <li><a href='/#contact-us'>Contact</a></li>
                    </ul>
                </div>
            </div>

            <div className='footer-terms'>
                <p>
                    © 2026 Silicon Surge. All Rights Reserved
                </p>

                <p>
                    Designed & Develop by <a href='https://www.bitoriq.com/'>Bitoriq</a>
                </p>
            </div>
        </div>
    )
}

export default Footer